import React from 'react'
import { useAnnouncements } from '../hooks/use-announcement'
import AnnouncementModal from './announcement-modal'

const Announcement = () => {
  const { active, dismiss, handleAction } = useAnnouncements()

  return (
    <>
      {active && (
        <AnnouncementModal
          data={active}
          onClose={dismiss}
          onAction={handleAction}
        />
      )}
    </>
  )
}

export default Announcement
